import { LuCheck } from 'react-icons/lu';

import { withStroke } from '../../utils/withStroke';

const CheckIcon = withStroke(LuCheck);

export { CheckIcon };
